(ns frontend.ui.component.lp-portal.report.body.real-estate.fund.stockholm-living.controller.financial-statements
  (:require
   [frontend.ui.component.lp-portal.report.controller :as report-ctl]))

(defn financial-statements
  [{:keys [report-data] :as props}]
  {:group-income-statement (report-ctl/with-footnote
                            props
                            :group-income-statement-footnotes
                            (get-in report-data [:group-income-statement]))
   :statement-of-financial-position (report-ctl/with-footnote
                                     props
                                     :statement-of-financial-position-footnotes
                                     (get-in report-data
                                             [:statement-of-financial-position]))
   :cash-flow-statement    (report-ctl/with-footnote
                            props
                            :cash-flow-statement-footnotes
                            (get-in report-data [:cash-flow-statement]))})
